import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";
import * as firebase from 'firebase';

export default action$ =>
  action$
    .ofType(Types.LOAD_PATH)
    .mergeMap(action =>
      firebase
        .database()
        .ref(action.path)
        .once("value")
        .then(snapshot => Creators.dataReceived(action.path, snapshot.val()))
        .catch(error => Creators.loadPathFailed(action.path))
    );



// WEBPACK FOOTER //
// ./src/data/epics/loadPath.js